import {Component, Input, OnInit} from "@angular/core";
import {Store} from "@ngrx/store";
import * as fromQuote from '../../reducers/index';
import * as quoteAction from '../../actions/quote.action';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Quote, QuoteConstants, QuoteItem} from "../../model/quote";
import * as fromRoot from '../../../reducers';
import * as LayoutActions from '../../../core/actions/layout.actions';
import {Product} from "src/app/products/models/product";


@Component({
    selector: 'add-to-quote-menu',
    styleUrls: ['./add-to-quote-menu.component.scss'],
    templateUrl: './add-to-quote-menu.component.html'
})
export class AddToQuoteMenuComponent implements OnInit {
    form: FormGroup;

    constructor(private store: Store<fromQuote.State>, private rootStore: Store<fromRoot.State>) {}

    @Input() selectedQuote: Quote;
    @Input() isLoading: boolean;
    @Input() product: Product;
    @Input() selectedQuantity: number;


    ngOnInit(): void {
        this.form = new FormGroup({
            quantity: new FormControl(this.selectedQuantity, [
                Validators.min(QuoteConstants.PRODUCT_QUANTITY_MIN_VALUE),
                Validators.max(QuoteConstants.PRODUCT_QUANTITY_MAX_VALUE)
            ])
        });
    }

    createQuote() {
        this.store.dispatch(quoteAction.closeAddToQuoteMenu());
        this.store.dispatch(quoteAction.openCreateNewQuote());
    }

    closeAddToQuote() {
        this.rootStore.dispatch(LayoutActions.closeQuoteList());
        this.store.dispatch(quoteAction.closeAddToQuoteMenu());
        this.store.dispatch(LayoutActions.closeQuoteViewSelection());
    }

    selectNewQuote() {
        this.store.dispatch(quoteAction.closeAddToQuoteMenu());
        this.store.dispatch(quoteAction.openChooseQuote());
    }

    addProduct() {
        if (this.form.valid && this.selectedQuote !== null) {
            console.debug(this.selectedQuote)
            const productQuoteItem: QuoteItem[] = this.selectedQuote.quoteItems.filter(qi => qi.productId === this.product.id);

            if (productQuoteItem.length > 0) {
                const quantity = Math.min(
                    productQuoteItem[0].quantity + +this.form.value.quantity,
                    QuoteConstants.PRODUCT_QUANTITY_MAX_VALUE
                );
                console.debug('Quote contains product already', productQuoteItem);
                console.debug('Set quantity to', quantity);
                this.store.dispatch(quoteAction.editProduct({
                    command: {
                        quote: this.selectedQuote,
                        product: this.product,
                        quantity: quantity
                    }
                }));
                this.store.dispatch(quoteAction.closeAddToQuoteMenu());
                this.store.dispatch(quoteAction.openQuoteListMenu());
                this.store.dispatch(quoteAction.addToQuoteQuantity({quantity: 1}));
            } else {
                const command = { command: { quote: this.selectedQuote, product: this.product, quantity: this.form.value.quantity } };
                this.store.dispatch(quoteAction.addProduct(command));
                this.store.dispatch(quoteAction.closeAddToQuoteMenu());
                this.store.dispatch(quoteAction.openQuoteListMenu());
                this.store.dispatch(quoteAction.addToQuoteQuantity({quantity: 1}));
            }
        }
    }

    changeQuantity() {
        this.store.dispatch(quoteAction.addToQuoteQuantity({quantity: this.form.get("quantity").value}))
    }
}
